/* eslint-disable */
import "../../components/component-questionnaire/B4FDate/react-datepicker.css";

import { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import AddCircleIcon from "@material-ui/icons/AddCircle";

import {
  addNetAssetPartValue,
  addNetAssetValue,
  deleteNetAssetPartValue,
  deleteNetAssetValue,
  getFund,
  getNetAssetPartValue,
  getNetAssetValue,
  getPart,
  updateFundPart,
} from "../../utils/store/actions/funds.actions";
import {
  Input,
  Button,
  Card,
  CardContent,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
} from "@material-ui/core";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import B4FCurrency from "../../components/component-questionnaire/B4FFields/B4FCurrency";

const styles = (theme: Theme) =>
  createStyles({
    card: {
      borderRadius: "12px",
      margin: "1%",
    },
  });
class PartBackInput extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      amount: {
        currency: "EUR",
        value: 0,
      },
      date: "",
    };
  }
  queryString = window.location.search;
  urlParams = new URLSearchParams(this.queryString);
  fundPersonId = this.urlParams.get("id");

  async componentDidMount() {
    this.setState({ part: this.props.Funds.part });
  }

  updateAmount = (e: any) => {
    if (e.id === "amount.value") {
      this.setState({
        ...this.state,
        amount: {
          ...this.state.amount,
          value: e.value,
        },
      });
    }
    if (e.id === "amount.currency") {
      this.setState({
        ...this.state,
        amount: {
          ...this.state.amount,
          currency: e.value,
        },
      });
    }
  };
  render() {
    const { classes, t } = this.props;

    return (
      <>
        <div style={{ margin: "1%", fontWeight: "bolder" }}>
          {t("LIQUIDATIVE_REPORTS")}
        </div>
        <Card className={classes.card}>
          <CardContent>
            <TableContainer component={Paper}>
              <Table stickyHeader aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">{t("DATE")}</TableCell>
                    <TableCell align="center">
                      {t("LIQUIDATIVE_VALUE")}
                    </TableCell>
                    <TableCell align="center"></TableCell>
                    <TableCell align="center"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.props.Funds?.net_asset_value_part_list?.map(
                    (netAssetValues: any) => (
                      <TableRow>
                        <TableCell align="center">
                          {netAssetValues.date}
                        </TableCell>
                        <TableCell align="center">
                          {netAssetValues.amount.value} {""}{" "}
                          {netAssetValues.amount.currency}
                        </TableCell>
                        <TableCell align="center"></TableCell>
                        <TableCell align="center">
                          <Button
                            onClick={() =>
                              this.props
                                .deleteNetAssetPartValue(
                                  this.fundPersonId,
                                  this.props.Funds.part.id,
                                  netAssetValues.id
                                )
                                .then(() =>
                                  this.props.getNetAssetPartValue(this.fundPersonId, this.props.Funds.part.id)
                                )
                            }
                          >
                            <DeleteOutlinedIcon />
                          </Button>
                        </TableCell>
                      </TableRow>
                    )
                  )}
                  {this.state.add_values && (
                    <TableRow>
                      <TableCell align="center">
                        <Input
                          value={this.state?.date || ""}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              date: e.target.value,
                            })
                          }
                          type="date"
                          placeholder={t("DATE")}
                          style={{
                            backgroundColor: "#fafcfe",
                            border: "1px solid #97A0C3",
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <B4FCurrency
                          label=""
                          id="amount"
                          value={
                            [
                              this.state.amount.value,
                              this.state.amount.currency,
                            ] || ["", ""]
                          }
                          onChange={this.updateAmount}
                          onUpdate={console.log}
                          onBlur={console.log}
                          visible={true}
                          isRequired={false}
                          disabled={false}
                        />
                      </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center">
                        <Button
                          onClick={(e) => {
                            e.preventDefault();
                            this.setState({ add_values: false });
                            this.props
                              .addNetAssetPartValue(this.state, this.fundPersonId, this.props.Funds.part.id)
                              .then(() =>
                                this.props.getNetAssetPartValue(this.fundPersonId, this.props.Funds.part.id)
                              );
                          }}
                        >
                          {t("ADD")}
                        </Button>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <div>
              <Button
                onClick={(e) =>
                  this.setState({
                    add_values: true,
                    values: {
                      ...this.state.values,
                    },
                  })
                }
              >
                <AddCircleIcon />
              </Button>
            </div>
          </CardContent>
        </Card>
      </>
    );
  }
}
const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getPart,
  updateFundPart,
  getFund,
  addNetAssetValue,
  addNetAssetPartValue,
  getNetAssetPartValue,
  getNetAssetValue,
  deleteNetAssetValue,
  deleteNetAssetPartValue,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(PartBackInput)));
